import script from "./MenuGroups.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuGroups.vue?vue&type=script&setup=true&lang=js"

import "./MenuGroups.vue?vue&type=style&index=0&id=3531d6dd&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3531d6dd"]])

export default __exports__